/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ days: NonNullable<unknown> }} Einvoice_Pending_SentenceInputs */

const vi_einvoice_pending_sentence = /** @type {(inputs: Einvoice_Pending_SentenceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Đơn đã giao ${i?.days} ngày, chưa xuất hóa đơn.`)
};

/**

* @param {Einvoice_Pending_SentenceInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_pending_sentence = /** @type {((inputs: Einvoice_Pending_SentenceInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Pending_SentenceInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_pending_sentence(inputs)
});